import "./EmailVerificationSuccess.scss";

function EmailVerificationSuccess() {
  return (
    <>
      <div>
        <div>
          <h1>
            ¡Verificación exitosa!
          </h1>
          <p>
            Su correo electrónico se verificó exitosamente, puede continuar su proceso de registro en BHappy.
          </p>
        </div>
        <div>
          <footer style={{ fontSize: "10px"}}>
            BHappy - Conectando servicios, Construyendo confianza.
          </footer>
        </div>
      </div>
    </>
  );
}

export default EmailVerificationSuccess;